<template>
  <v-data-table
    :headers="headers"
    :items="servicePlans"
    show-expand
    single-expand
    :expanded.sync="expanded"
    item-key="servicePlanId"
    :item-class="highlightExpandedRow"
    :items-per-page="-1"
    hide-default-footer
    class="primary--text"
    :key="servicePlans.length"
    @click:row="rowClicked"
    :sort-by="['program', 'service', 'startDate']"
    :sort-desc="[false, false, true]"
  >
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="expandedRow">
        <provider-assignments-table
          :viewOnly="viewOnly"
          :servicePlanId="item.servicePlanId"
        ></provider-assignments-table>
        <v-card-actions class="justify-center white mb-3 py-3">
          <provider-assignment-form
            v-if="!viewOnly && item.isSeitOrPend"
            :servicePlanId="item.servicePlanId"
          ></provider-assignment-form>
        </v-card-actions>
      </td>
    </template>
    <template v-slot:[`item.program`]="{ item }">
      {{ item.program }}
      <v-chip
        :active="Boolean(item.isCompensatorySummer)"
        x-small
        pill
        label
        color="accent"
        class="ma-2"
      >
        Compensatory
      </v-chip></template
    >
    <template v-slot:[`item.actions`]="{ item }">
      <div class="d-flex flex-nowrap">
        <service-plan-form
          v-if="canEdit(item)"
          :planId="planId"
          :servicePlan="item"
        ></service-plan-form>
        <delete-modal
          v-if="canEdit(item)"
          :disabled="!canDelete(item)"
          disabledTooltip="Cannot remove service plan with assignments"
          title="Are you sure you want to REMOVE this service plan?"
          message="Note: This action cannot be undone."
          @save="deleteServicePlan($event, item)"
        ></delete-modal>
      </div>
    </template>
    <template v-if="!viewOnly" v-slot:[`footer`]="{}">
      <v-card-actions class="justify-center">
        <service-plan-form :planId="planId"></service-plan-form>
      </v-card-actions>
    </template>
  </v-data-table>
</template>

<script>
import ServicePlanForm from "./service-plan-form";
import ProviderAssignmentsTable from "./provider-assignments-table";
import ProviderAssignmentForm from "./provider-assignment-form.vue";
import DeleteModal from "../../Shared/delete-modal";
export default {
  components: {
    ServicePlanForm,
    ProviderAssignmentsTable,
    ProviderAssignmentForm,
    DeleteModal,
  },
  props: ["planId", "viewOnly"],
  data() {
    return {
      headers: [
        { text: "Program", value: "program" },
        { text: "Service", value: "service" },
        { text: "Mandate", value: "mandate" },
        { text: "Location", value: "sessionLocation" },
        { text: "Auth Start Date", value: "formattedStartDate" },
        { text: "Auth End Date", value: "formattedEndDate" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      expanded: [],
    };
  },
  computed: {
    servicePlans() {
      var plan = this.$store.state.plansModule.plans.find(
        (item) => item.planId == this.planId
      );
      return plan.servicePlans;
    },
  },
  methods: {
    rowClicked: function (row, { isExpanded }) {
      this.expanded = isExpanded ? [] : [row];
    },
    highlightExpandedRow: function (row) {
      return (
        this.expanded[0]?.servicePlanId === row.servicePlanId && "expandedRow"
      );
    },
    canEdit(servicePlan) {
      return (
        !this.viewOnly &&
        (servicePlan.isSeitOrPend || servicePlan.isRelatedServices)
      );
    },
    canDelete(servicePlan) {
      return servicePlan.assignments.length == 0;
    },
    deleteServicePlan: async function (comments, item) {
      this.$store.commit("uxModule/setShowLoader", true);
      var message = await this.$store.dispatch(
        "plansModule/deleteServicePlan",
        {
          servicePlanId: item.servicePlanId,
          comments: comments,
        }
      );
      this.$store.commit("uxModule/setShowLoader", false);
      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
    },
  },
};
</script>
<style>
.expandedRow {
  background: #ccc;
}
</style>
